// Flags for various stuff

class _GlobalFlags {
    public InstrumentSaveMode: boolean = false;
}

export const GlobalFlags = new _GlobalFlags();
